import { AxiosError } from 'axios';
import {
  CreateMeetingResult,
  ILanguage,
  IMeeting,
  ITopic,
  LanguageLevel,
  MeetingType,
  ICustomMeetingInfo,
  IParticipant,
  IOrganization,
  IImage,
} from 'lingopractices-models';
import { DatesFilterEnum, TDateRange } from 'screens/AllMeetings/types';
import { ICoords } from 'screens/types';

export enum TopicEnum {
  OUR = 1,
  CUSTOM = 2,
}

export enum MeetingPlace {
  Online = 1,
  Offline = 2,
}

export type TCreateMeetingData = {
  language?: ILanguage;
  level?: LanguageLevel;
  topic?: ITopic;
  customTopic?: string;
  customTopicDescription?: string;
  note?: string;
  date?: string;
  time?: string;
  location?: string;
  shortLocation?: string;
  meetingType: MeetingType;
  participantsCount: number;
  topicType: TopicEnum;
  latLng?: ICoords;
  customMeetingInfo?: ICustomMeetingInfo;
  duration: number;
  preferVideo: boolean;
};

export type IMeetingFilter = {
  languageId: string | null;
  level: LanguageLevel | null;
  date: {
    dateType: DatesFilterEnum | null;
    customDate?: TDateRange | null;
  } | null;
  place: MeetingPlace | null;
};

export interface ISelectedParticipantInfo extends IParticipant {
  meetingId: number;
  organization?: IOrganization;
  image?: IImage;
}

export interface IMeetingsState {
  meetings: {
    meetingList: IMeeting[];
    meetingListPast: IMeeting[];
    hasMore: boolean;
    hasMorePast: boolean;
  };
  myMeetings: {
    meetingList: IMeeting[];
    meetingListPast: IMeeting[];
    hasMore: boolean;
    hasMorePast: boolean;
    selectedMeeting: IMeeting | null;
  };
  filters: {
    myMeetingsFilter: IMeetingFilter;
    allMeetingsFilter: IMeetingFilter;
    isMyMeetingsOpened: boolean;
  };
  createMeetingData: TCreateMeetingData;

  requests: {
    getMeetingsPending: boolean;
    getMyMeetingsPending: boolean;
    createMeetingPending: boolean;
    joinMeetingPending: boolean;
    leaveMeetingPending: boolean;
    editMeetingNotificationPending: boolean;
    editMeetingPending: boolean;
  };
}

export interface IGetMeetingSuccessPayload {
  data: IMeeting[];
  hasMore: boolean;
  initializedByScroll: boolean;
}

export type CreateMeetingError = {
  e: CreateMeetingResult & AxiosError;
  url?: string;
};
